import "./MarketingHero.css";
import React from "react";
import PropTypes from "prop-types";

const MarketingHero = ({
    desktopImage,
    tabletImage,
    mobileImage,
    children,
    buttonHref,
    buttonText,
    allowLinkNewTab,
    containsChevron,
    logo
}) => {
    return (
        <div className="marketing-hero">
            {desktopImage && <img alt="Hero" className="desktop-image" src={desktopImage} />}
            {tabletImage && <img alt="Hero" className="tablet-image" src={tabletImage} />}
            {mobileImage && <img alt="Hero" className="mobile-image" src={mobileImage} />}
            <div className="hero-body-wrapper">
                <div className="hero-body">
                    {containsChevron && <img className="chevron" alt="chevron" src={require("../assets/redesign2020/chevron-darker.svg")} />}
                    {logo && <img className="logo" alt="logo" src={logo} /> }
                    <h1 className="hero-text">
                        {children}
                    </h1>
                    {buttonText && <a className="button" href={buttonHref} target={allowLinkNewTab && "_blank"}>{buttonText}</a>}
                </div>
            </div>
        </div>
    );
};

MarketingHero.propTypes = {
    desktopImage: PropTypes.string,
    tabletImage: PropTypes.string,
    mobileImage: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonText: PropTypes.string,
    containsChevron: PropTypes.bool,
    logo: PropTypes.string
};

export default MarketingHero;